module.exports = __webpack_public_path__ + "static/media/home-slide-5.a3c9fcf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MainImage/home-slide-5.jpg
// module id = 340
// module chunks = 0